import img1 from './assets/STFC_PlayerCard.png';
import img2 from './assets/STFC_CaptainCard.png';
import familyPhoto from './assets/IMG_3368.png';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Menu, X, Mail, ExternalLink } from 'lucide-react';
import stfcLeaderboard from './assets/STFC_Leaderboard.png';
import stfcStats from './assets/STFC_Stats.png';
import stfcPlay from './assets/STFC_Play.mp4';
import stfcTrophyRoom from './assets/STFC_TrophyRoom.mp4';
import stfcMilestone from './assets/STFC_Milestone.mp4';
import stfcPit from './assets/STFC_Pit.jpeg';
import stfcWebsite1 from './assets/STFC_Website1.png';
import stfcWebsite2 from './assets/STFC_Website2.png';
import stfcWebsite3 from './assets/STFC_Website3.png';
import stfcWebsite4 from './assets/STFC_Website4.png';
import stfcWebsite5 from './assets/STFC_Website5.png';
import stfcWebsite6 from './assets/STFC_Website6.png';
import stfcWebsite7 from './assets/STFC_Website7.png';
import stfcWebsite4b from './assets/STFC_Website4b.png';
import stfcWebsite8 from './assets/STFC_Website8.png';
import local1 from './assets/Local_1.png';
import local2 from './assets/Local_2.png';
import local3 from './assets/Local_3.png';
import local4 from './assets/Local_4.png';
import local5 from './assets/Local_5.png';
import local6 from './assets/Local_6.png';
import growth1 from './assets/Growth_1.png';
import growth2 from './assets/Growth_2.png';
import growth3 from './assets/Growth_3.png';
import growth4 from './assets/Growth_4.png';
import growth5 from './assets/Growth_5.png';
import growth6 from './assets/Growth_6.png';
import growth7 from './assets/Growth_7.png';

const GOLD  = '#D4AF37';
const BURG  = '#800020';
const CREAM = '#F5F5F0';
const SERIF = "'Playfair Display', Georgia, serif";
const SANS  = "'Work Sans', system-ui, sans-serif";

/* ── Mini Carousel ── */
const MiniCarousel = ({ media, count, label, portrait, arrows, active, bg }) => {
  const [idx, setIdx] = useState(0);
  const videoRefs = useRef({});

  // Build slides from media array or fall back to placeholder count
  const slides = media || Array.from({ length: count }, (_, i) => ({ type: 'placeholder', label: `${label} ${i + 1}` }));

  const setVideoRef = useCallback((i, el) => {
    videoRefs.current[i] = el;
  }, []);

  // Autoplay active video only when card is expanded, pause/reset when collapsed
  useEffect(() => {
    Object.entries(videoRefs.current).forEach(([i, vid]) => {
      if (!vid) return;
      if (active && Number(i) === idx) {
        vid.play().catch(() => {});
      } else {
        vid.pause();
        vid.currentTime = 0;
      }
    });
  }, [idx, active]);

  return (
    <div onClick={e => e.stopPropagation()}>
      <div style={{ position: 'relative', width: '100%', paddingBottom: portrait ? '170%' : '62%', overflow: 'hidden', border: `1px solid ${GOLD}`, boxShadow: '0 8px 30px rgba(0,0,0,0.2)', borderRadius: (portrait || arrows) ? '12px' : '0', backgroundColor: bg || ((portrait || arrows) ? '#000000' : 'transparent') }}>
        {slides.map((slide, i) => (
          <div key={i} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: idx === i ? 1 : 0, transition: 'opacity 1.2s ease-in-out', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(245,245,240,0.04)', padding: slide.padding || 0 }}>
            {slide.type === 'image' && (
              <img src={slide.src} alt="" style={{ width: '100%', height: '100%', objectFit: (portrait || arrows) ? 'contain' : 'cover' }} />
            )}
            {slide.type === 'video' && (
              <video
                ref={el => setVideoRef(i, el)}
                src={slide.src}
                muted
                loop
                playsInline
                style={{ width: '100%', height: '100%', objectFit: (portrait || arrows) ? 'contain' : 'cover' }}
              />
            )}
            {slide.type === 'placeholder' && (
              <p style={{ fontFamily: SANS, fontSize: '0.75rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(245,245,240,0.3)' }}>{slide.label}</p>
            )}
          </div>
        ))}
        {(portrait || arrows) && slides.length > 1 && (
          <>
            <button onClick={() => setIdx(i => (i - 1 + slides.length) % slides.length)}
              style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.4)', border: `1px solid rgba(212,175,55,0.4)`, color: GOLD, width: '36px', height: '36px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', transition: 'all 0.3s ease', zIndex: 2, padding: 0 }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.7)'; e.currentTarget.style.borderColor = GOLD; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.4)'; e.currentTarget.style.borderColor = 'rgba(212,175,55,0.4)'; }}
            >&lsaquo;</button>
            <button onClick={() => setIdx(i => (i + 1) % slides.length)}
              style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.4)', border: `1px solid rgba(212,175,55,0.4)`, color: GOLD, width: '36px', height: '36px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', transition: 'all 0.3s ease', zIndex: 2, padding: 0 }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.7)'; e.currentTarget.style.borderColor = GOLD; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.4)'; e.currentTarget.style.borderColor = 'rgba(212,175,55,0.4)'; }}
            >&rsaquo;</button>
          </>
        )}
      </div>
      {(portrait || arrows) ? (
        <div style={{ textAlign: 'center', marginTop: '1rem', fontFamily: SANS, fontSize: '0.75rem', letterSpacing: '0.1em', color: GOLD, opacity: 0.6 }}>
          {idx + 1} / {slides.length}
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem', marginTop: '1.25rem' }}>
          {slides.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} style={{ width: idx === i ? '10px' : '7px', height: idx === i ? '10px' : '7px', borderRadius: '50%', border: `1px solid ${GOLD}`, backgroundColor: idx === i ? GOLD : 'transparent', cursor: 'pointer', transition: 'all 0.3s ease', padding: 0 }} />
          ))}
        </div>
      )}
    </div>
  );
};

/* ── Intro Image Fader ── */
const ImageFader = () => {
  const [cur, setCur] = useState(0);
  // Uncomment below and remove PostImages URLs when running locally:
  const images = [img1, img2];
  useEffect(() => {
    const t = setInterval(() => setCur(i => (i + 1) % images.length), 5000);
    return () => clearInterval(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div style={{ marginTop: '3rem', maxWidth: '320px', margin: '3rem auto 0' }}>
      <div style={{ position: 'relative', width: '100%', paddingBottom: '125%', overflow: 'hidden', border: `1px solid ${GOLD}`, boxShadow: '0 20px 60px rgba(128,0,32,0.15)', borderRadius: '20px' }}>
        {images.map((img, i) => (
          <div key={i} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: cur === i ? 1 : 0, transition: 'opacity 1.5s ease-in-out', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(128,0,32,0.04)' }}>
            {img
              ? <img src={img} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              :             <p style={{ fontFamily: SANS, fontSize: '0.85rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: CREAM, opacity: 0.35 }}>Photo Coming Soon</p>
            }
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '2.5rem' }}>
        {images.map((_, i) => (
          <button key={i} onClick={() => setCur(i)} style={{ width: cur === i ? '12px' : '8px', height: cur === i ? '12px' : '8px', borderRadius: '50%', border: `1px solid ${GOLD}`, backgroundColor: cur === i ? GOLD : 'transparent', cursor: 'pointer', transition: 'all 0.3s ease', padding: 0 }} />
        ))}
      </div>
    </div>
  );
};

/* ── Theme Chips ── */
const Chips = ({ themes }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
    {themes.map((t, i) => (
      <span key={i} style={{ fontFamily: SANS, fontSize: '0.7rem', letterSpacing: '0.08em', textTransform: 'uppercase', color: GOLD, border: `1px solid rgba(212,175,55,0.35)`, padding: '0.3rem 0.65rem', fontWeight: '400' }}>{t}</span>
    ))}
  </div>
);

/* ── Section Divider ── */
const SectionDivider = ({ from = CREAM, to = BURG }) => (
  <div style={{ position: 'relative' }}>
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '50%', backgroundColor: from }} />
    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '50%', backgroundColor: to }} />
    <div style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem 0' }}>
      <div style={{ display: 'flex', alignItems: 'center', width: '100%', maxWidth: '600px', padding: '0 1.5rem' }}>
        <div style={{ flex: 1, height: '3px', background: `linear-gradient(to right, transparent, ${GOLD})` }} />
        <div style={{ margin: '0 1.5rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{ width: '4px', height: '4px', backgroundColor: GOLD, borderRadius: '50%', opacity: 0.85 }} />
          <div style={{ width: '10px', height: '10px', backgroundColor: GOLD, transform: 'rotate(45deg)', opacity: 1 }} />
          <div style={{ width: '4px', height: '4px', backgroundColor: GOLD, borderRadius: '50%', opacity: 0.85 }} />
        </div>
        <div style={{ flex: 1, height: '3px', background: `linear-gradient(to left, transparent, ${GOLD})` }} />
      </div>
    </div>
  </div>
);

const navLabel = s => s === 'building' ? 'Current' : s.charAt(0).toUpperCase() + s.slice(1);

const NoiseOverlay = () => {
  const canvasRef = React.useRef(null);
  const copyRef = React.useRef(null);
  const [pageHeight, setPageHeight] = React.useState(window.document.body.scrollHeight);

  useEffect(() => {
    const updateHeight = () => setPageHeight(document.body.scrollHeight);
    updateHeight();
    const ro = new ResizeObserver(updateHeight);
    ro.observe(document.body);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const copy = copyRef.current;
    if (!canvas || !copy || pageHeight === 0) return;

    const w = 600;
    const h = pageHeight;
    canvas.width = w; canvas.height = h;
    copy.width = w;   copy.height = h;

    const ctx = canvas.getContext('2d');
    const imageData = ctx.createImageData(w, h);

    // Simple hash for deterministic pseudo-random per pixel
    const hash = (a, b) => {
      let h = (a * 2654435761 ^ b * 2246822519) >>> 0;
      h = ((h >> 16) ^ h) * 0x45d9f3b; h = ((h >> 16) ^ h) * 0x45d9f3b; h = (h >> 16) ^ h;
      return (h & 0xffff) / 0xffff;
    };

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        // Fine grain noise — paper speckle
        const grain = hash(x, y);
        // Subtle horizontal fiber lines
        const fiber = hash(Math.floor(x * 0.5), y * 3) * 0.6;
        // Combine: mostly grain with a hint of directional texture
        const v = Math.floor((grain * 0.7 + fiber) * 255);
        const i = (y * w + x) * 4;
        imageData.data[i]     = v;
        imageData.data[i + 1] = v;
        imageData.data[i + 2] = v;
        imageData.data[i + 3] = 33;
      }
    }
    ctx.putImageData(imageData, 0, 0);
    copy.getContext('2d').drawImage(canvas, 0, 0);
  }, [pageHeight]);

  const base = { position: 'absolute', top: 0, left: 0, width: '100%', height: `${pageHeight}px`, pointerEvents: 'none' };
  return (
    <>
      <canvas ref={canvasRef} style={{ ...base, zIndex: 9999, mixBlendMode: 'soft-light' }} />
      <canvas ref={copyRef}   style={{ ...base, zIndex: 9998, mixBlendMode: 'multiply', opacity: 0.18 }} />
    </>
  );
};

export default function DerekMcAbeePortfolio() {
  const [menuOpen, setMenuOpen]               = useState(false);
  const [activeSection, setActiveSection]     = useState('about');
  const [isMobile, setIsMobile]               = useState(window.innerWidth < 768);
  const [activeBuild, setActiveBuild]         = useState(null);
  const [activePortfolio, setActivePortfolio] = useState(null);

  const sections = ['about', 'building', 'experience', 'portfolio', 'contact'];

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      const pos = window.scrollY + 100;
      sections.forEach(s => {
        const el = document.getElementById(s);
        if (el && pos >= el.offsetTop && pos < el.offsetTop + el.offsetHeight) setActiveSection(s);
      });
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollTo = id => { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); setMenuOpen(false); };

  const navBtn = s => (
    <button key={s} onClick={() => scrollTo(s)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontFamily: SANS, fontSize: '0.8rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: activeSection === s ? GOLD : BURG, fontWeight: activeSection === s ? '500' : '400', transition: 'color 0.3s ease' }}>
      {navLabel(s)}
    </button>
  );

  const experience = [
    { role: 'Head of Growth & Product', org: 'Street FC',               years: '2022–2024' },
    { role: 'Senior Product Manager',   org: 'Decile',                  years: '2019–2021' },
    { role: 'Product / SaaS Licensing / Digital Marketing', org: 'SocialCode', years: '2012–2018' },
    { role: 'Economics & Soccer',       org: 'Johns Hopkins University', years: '2008–2012' },
  ];

  const buildItems = [
    {
      key: 'family', title: 'Family!', body: "Baby girl on the way, summer '26.",
      reveal: (
      <div style={{ marginTop: '2rem' }}>
      <img src={familyPhoto} alt="Family" style={{ width: '80%', maxWidth: '240px', display: 'block', margin: '0 auto', border: `1px solid ${GOLD}`, borderRadius: '8px' }} />
      </div>
  )
    },
    {
      key: 'streetfc', title: 'Street FC', body: 'The biggest football club on the planet.',
      reveal: (
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <a href="https://www.streetfc.city/" target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}
            style={{ display: 'inline-block', border: `1px solid ${GOLD}`, color: GOLD, padding: '1rem 2.5rem', fontSize: '0.85rem', letterSpacing: '0.15em', textTransform: 'uppercase', textDecoration: 'none', fontFamily: SANS, transition: 'all 0.3s ease', borderRadius: '10px' }}
            onMouseEnter={e => { e.target.style.backgroundColor = GOLD; e.target.style.color = BURG; }}
            onMouseLeave={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = GOLD; }}
          >Join the Club</a>
          <div style={{ marginTop: '2rem' }}>
            <img src={stfcPit} alt="Street FC" style={{ width: '100%', border: `1px solid ${GOLD}`, borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }} />
          </div>
        </div>
      )
    },
  ];

  const portfolioItems = [
    {
      key: 'app', title: 'Street FC App', date: 'Ongoing',
      themes: ['UX', 'Gamification', 'User Research', 'Product-Led Growth'],
      description: 'Find pickup games locally, improve your skill rating, unlock milestones and connect with community.',
      links: [{ label: 'Web App', href: 'https://streetfc.com/app' }, { label: 'iOS', href: 'https://apps.apple.com/us/app/street-fc/id1467382935' }, { label: 'Android', href: 'https://play.google.com/store/apps/details?id=com.streetfc&hl=en_US' }],
      carousel: { portrait: true, media: [
        { type: 'video', src: stfcPlay, padding: '1.5rem 0' },
        { type: 'image', src: stfcStats, padding: '1.25rem 0' },
        { type: 'video', src: stfcTrophyRoom },
        { type: 'video', src: stfcMilestone },
        { type: 'image', src: stfcLeaderboard, padding: '1.25rem 0' },
      ] }
    },
    {
      key: 'site', title: 'StreetFC.com', date: 'Ongoing',
      themes: ['UX', 'IA', 'Go-to-Market'],
      description: 'Bring Street FC to your town or city, or get involved with the existing community.',
      links: [{ label: 'Visit Site', href: 'https://www.streetfc.city/' }],
      carousel: { arrows: true, media: [
        { type: 'image', src: stfcWebsite1 },
        { type: 'image', src: stfcWebsite2 },
        { type: 'image', src: stfcWebsite3 },
        { type: 'image', src: stfcWebsite4 },
        { type: 'image', src: stfcWebsite4b },
        { type: 'image', src: stfcWebsite5 },
        { type: 'image', src: stfcWebsite6 },
        { type: 'image', src: stfcWebsite7 },
        { type: 'image', src: stfcWebsite8 },
      ] }
    },
    {
      key: 'slam', title: 'National Street Slam', date: '2025',
      themes: ['Event Production (Qualifiers)', 'MC (Final)'],
      description: '13 Street FC communities hosted qualifiers across the country. Winners earned a trip to LA to compete for the inaugural "Street Slam" championship. Sponsored by VW and Nike.',
      links: [{ label: 'Instagram', href: 'https://www.instagram.com/reel/DTvhv9kDEwJ/?igsh=MWZwNXRweG51eXA3eA==' }],
      carousel: null,
      embed: 'https://www.canva.com/design/DAG5RhOqIvw/ruIehfSHZmgOZwy5VvDiIA/view?embed'
    },
    {
      key: 'local', title: 'Local Ownership', date: '2025',
      themes: ['Localization', 'Incentive Systems', 'OS for Organizers'],
      description: 'Street FC organizers receive the tools, incentives & support to take true ownership of their markets and build community from the ground up.',
      links: [],
      carousel: { arrows: true, bg: '#ffffff', media: [
        { type: 'image', src: local1 },
        { type: 'image', src: local2 },
        { type: 'image', src: local3 },
        { type: 'image', src: local4 },
        { type: 'image', src: local5 },
        { type: 'image', src: local6 },
      ] }
    },
    {
      key: 'growth', title: 'Community Growth', date: '2022–2024',
      themes: ['Acquisition', 'Conversion', 'Retention'],
      description: 'From a few weekly games in 2 markets to over 100 weekly games across 14 markets, 1500+ regular players and millions of $ in revenue.',
      links: [],
      carousel: { arrows: true, bg: '#ffffff', media: [
        { type: 'image', src: growth1 },
        { type: 'image', src: growth2 },
        { type: 'image', src: growth3 },
        { type: 'image', src: growth4 },
        { type: 'image', src: growth5 },
        { type: 'image', src: growth6 },
        { type: 'image', src: growth7 },
      ] }
    },
    {
      key: 'decile', title: 'Decile SaaS', date: '2019–2021',
      themes: ['Customer Insights', 'Data Integration'],
      description: 'Customer analytics Shopify platform for disruptor e-commerce brands.',
      links: [{ label: 'Shopify App Store', href: 'https://apps.shopify.com/decile-app' }],
      carousel: null
    },
  ];

  return (
    <div style={{ fontFamily: SANS, color: BURG, position: 'relative', overflowX: 'hidden' }}>
      <NoiseOverlay />
      {/* Remove old noise div */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500&family=Work+Sans:wght@300;400;500&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        html { scroll-behavior: smooth; }
      `}</style>

      {/* NAV */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, backgroundColor: 'rgba(245,245,240,0.98)', backdropFilter: 'blur(10px)', borderBottom: '1px solid rgba(128,0,32,0.08)' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: isMobile ? '1.25rem 1.5rem' : '1.75rem 3rem', display: 'flex', justifyContent: isMobile ? 'flex-end' : 'center', alignItems: 'center' }}>
          {!isMobile && <div style={{ display: 'flex', gap: '3rem' }}>{sections.map(navBtn)}</div>}
          {isMobile && (
            <button onClick={() => setMenuOpen(!menuOpen)} style={{ background: 'none', border: 'none', color: BURG, cursor: 'pointer', padding: 0 }}>
              {menuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          )}
        </div>
        {isMobile && menuOpen && (
          <div style={{ backgroundColor: CREAM, borderTop: '1px solid rgba(128,0,32,0.08)', padding: '1.5rem 1.5rem' }}>
            {sections.map(s => (
              <button key={s} onClick={() => scrollTo(s)} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '1rem 0', background: 'none', border: 'none', cursor: 'pointer', fontFamily: SANS, fontSize: '0.9rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: activeSection === s ? GOLD : BURG, fontWeight: activeSection === s ? '500' : '400' }}>
                {navLabel(s)}
              </button>
            ))}
          </div>
        )}
      </nav>

      {/* ABOUT */}
      <section id="about" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundColor: CREAM, padding: isMobile ? '6rem 1.5rem 3rem' : '8rem 3rem 4rem' }}>
        <div style={{ textAlign: 'center', maxWidth: '900px', width: '100%' }}>
          <h1 style={{ fontFamily: SERIF, fontSize: 'clamp(2.2rem, 6vw, 5rem)', fontWeight: '400', letterSpacing: isMobile ? '0.08em' : '0.18em', color: BURG, lineHeight: 1.2, textShadow: '0 1px 2px rgba(128,0,32,0.08)' }}>DEREK MCABEE</h1>
          <div style={{ width: '20%', height: '1px', backgroundColor: GOLD, margin: '3rem auto' }} />
          <p style={{ fontFamily: SANS, fontSize: 'clamp(1.25rem, 3vw, 1.5rem)', fontWeight: '400', color: BURG, marginBottom: '1rem', letterSpacing: '0.05em' }}>GM @ Street FC</p>
          <p style={{ fontFamily: SANS, fontSize: 'clamp(0.95rem, 2vw, 1.1rem)', fontWeight: '400', color: BURG, opacity: 0.85, letterSpacing: '0.02em', lineHeight: 1.9 }}>Product leader. Community maximalist. Street footballer.</p>
          <ImageFader />
        </div>
      </section>
      <SectionDivider from={CREAM} to={BURG} />

      {/* CURRENTLY BUILDING */}
      <section id="building" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: BURG, padding: isMobile ? '4rem 1.5rem' : '6rem 3rem' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', width: '100%' }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: '400', letterSpacing: '0.18em', marginBottom: '5rem', color: CREAM, textAlign: 'center', textShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
            CURRENTLY BUILDING&hellip;
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fit, minmax(${isMobile ? '100%' : '320px'}, 1fr))`, gap: isMobile ? '2rem' : '3rem' }}>
            {buildItems.map(item => {
              const isActive = activeBuild === item.key;
              return (
                <div key={item.key} onClick={() => setActiveBuild(isActive ? null : item.key)}
                  style={{ textAlign: 'center', padding: isMobile ? '2rem 1.25rem' : '3rem 2.5rem', cursor: 'pointer', border: `2px solid ${isActive ? GOLD : 'rgba(245,245,240,0.4)'}`, backgroundColor: isActive ? 'rgba(212,175,55,0.08)' : 'transparent', transition: 'all 0.3s ease', borderRadius: '10px' }}
                  onMouseEnter={e => { if (!isActive) { e.currentTarget.style.borderColor = GOLD; e.currentTarget.style.borderWidth = '2px'; e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.05)'; }}}
                  onMouseLeave={e => { if (!isActive) { e.currentTarget.style.borderColor = 'rgba(245,245,240,0.4)'; e.currentTarget.style.borderWidth = '2px'; e.currentTarget.style.backgroundColor = 'transparent'; }}}
                >
                  <h3 style={{ fontFamily: SERIF, fontSize: '1.75rem', fontWeight: '400', marginBottom: '1.25rem', color: GOLD, letterSpacing: '0.07em', textShadow: '0 1px 2px rgba(212,175,55,0.1)' }}>{item.title}</h3>
                  <p style={{ fontFamily: SANS, lineHeight: 1.9, fontWeight: '300', color: CREAM, opacity: 0.9, fontSize: '1.05rem' }}>{item.body}</p>
                  <div style={{ maxHeight: isActive ? '800px' : '0', overflow: 'hidden', transition: 'max-height 0.6s ease' }}>
                    {item.reveal}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <SectionDivider from={BURG} to={CREAM} />

      {/* PREVIOUSLY */}
      <section id="experience" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: CREAM, padding: isMobile ? '4rem 1.5rem' : '6rem 3rem' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', width: '100%' }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: '400', letterSpacing: '0.18em', marginBottom: '5rem', color: BURG, textAlign: 'center', textShadow: '0 1px 2px rgba(128,0,32,0.08)' }}>
            PREVIOUSLY&hellip;
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            {experience.map((item, i) => (
              <div key={i}
                style={{ padding: isMobile ? '1.5rem 1.25rem' : '2.5rem 3rem', borderLeft: '1px solid rgba(128,0,32,0.15)', transition: 'all 0.3s ease' }}
                onMouseEnter={e => { e.currentTarget.style.borderLeftColor = GOLD; e.currentTarget.style.borderLeftWidth = '2px'; e.currentTarget.style.paddingLeft = isMobile ? '1.1rem' : '2.9rem'; }}
                onMouseLeave={e => { e.currentTarget.style.borderLeftColor = 'rgba(128,0,32,0.15)'; e.currentTarget.style.borderLeftWidth = '1px'; e.currentTarget.style.paddingLeft = isMobile ? '1.25rem' : '3rem'; }}
              >
                {isMobile ? (
                  <>
                    <div style={{ fontFamily: SANS, fontSize: '0.85rem', fontWeight: '500', color: GOLD, letterSpacing: '0.08em', marginBottom: '0.4rem' }}>{item.years}</div>
                    <div style={{ fontFamily: SANS, fontSize: '0.95rem', color: BURG, lineHeight: 1.6 }}>
                      <span style={{ fontWeight: '400' }}>{item.role}</span>
                      <span style={{ fontWeight: '400' }}> @ </span>
                      <span style={{ fontWeight: '700' }}>{item.org}</span>
                    </div>
                  </>
                ) : (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '2rem' }}>
                    <div style={{ fontFamily: SANS, fontSize: '1.1rem', color: BURG, lineHeight: 1.6, flex: '1 1 auto' }}>
                      <span style={{ fontWeight: '400' }}>{item.role}</span>
                      <span style={{ fontWeight: '400' }}> @ </span>
                      <span style={{ fontWeight: '700' }}>{item.org}</span>
                    </div>
                    <div style={{ fontFamily: SANS, fontSize: '1.05rem', fontWeight: '500', color: GOLD, letterSpacing: '0.08em', flexShrink: 0 }}>{item.years}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <SectionDivider from={CREAM} to={BURG} />

      {/* PROOF OF WORK */}
      <section id="portfolio" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: BURG, padding: isMobile ? '4rem 1.5rem' : '6rem 3rem' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', width: '100%' }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: '400', letterSpacing: '0.18em', marginBottom: '5rem', color: CREAM, textAlign: 'center', textShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
            PROOF OF WORK&hellip;
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fit, minmax(${isMobile ? '100%' : '320px'}, 1fr))`, gap: isMobile ? '1.5rem' : '2.5rem' }}>
            {portfolioItems.map(item => {
              const isActive = activePortfolio === item.key;
              return (
                <div key={item.key} onClick={() => setActivePortfolio(isActive ? null : item.key)}
                  style={{ padding: isMobile ? '2rem 1.25rem' : '3rem 2.5rem', cursor: 'pointer', border: `2px solid ${isActive ? GOLD : 'rgba(245,245,240,0.4)'}`, backgroundColor: isActive ? 'rgba(212,175,55,0.07)' : 'transparent', transition: 'all 0.3s ease', borderRadius: '10px' }}
                  onMouseEnter={e => { if (!isActive) { e.currentTarget.style.borderColor = GOLD; e.currentTarget.style.borderWidth = '2px'; e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.04)'; }}}
                  onMouseLeave={e => { if (!isActive) { e.currentTarget.style.borderColor = 'rgba(245,245,240,0.4)'; e.currentTarget.style.borderWidth = '2px'; e.currentTarget.style.backgroundColor = 'transparent'; }}}
                >
                  {/* Title + Date */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
                    <h3 style={{ fontFamily: SERIF, fontSize: '1.5rem', fontWeight: '400', color: GOLD, letterSpacing: '0.07em', textShadow: '0 1px 2px rgba(212,175,55,0.1)' }}>{item.title}</h3>
                    <span style={{ fontFamily: SANS, fontSize: '0.8rem', fontWeight: '300', color: CREAM, opacity: 0.5, letterSpacing: '0.08em', flexShrink: 0 }}>{item.date}</span>
                  </div>
                  {/* Description */}
                  <p style={{ fontFamily: SANS, color: CREAM, fontSize: '0.95rem', lineHeight: 1.8, opacity: 0.95, fontWeight: '400', marginBottom: '1.25rem' }}>{item.description}</p>
                  {/* Theme chips — always visible */}
                  <Chips themes={item.themes} />
                  {/* Expanded content */}
                  <div style={{ maxHeight: isActive ? '800px' : '0', overflow: 'hidden', transition: 'max-height 0.7s ease' }}>
                    <div style={{ paddingTop: '2rem' }}>
                      {item.links.length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginBottom: (item.carousel || item.embed) ? '2rem' : '0' }}>
                          {item.links.map((l, j) => (
                            <a key={j} href={l.href} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}
                              style={{ fontFamily: SANS, color: CREAM, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.95rem', transition: 'color 0.3s ease' }}
                              onMouseEnter={e => e.currentTarget.style.color = GOLD}
                              onMouseLeave={e => e.currentTarget.style.color = CREAM}
                            ><ExternalLink size={14} />{l.label}</a>
                          ))}
                        </div>
                      )}
                      {item.carousel && <MiniCarousel media={item.carousel.media} count={item.carousel.count} label={item.carousel.label} portrait={item.carousel.portrait} arrows={item.carousel.arrows} active={isActive} bg={item.carousel.bg} />}
                      {item.embed && isActive && (
                        <div onClick={e => e.stopPropagation()} style={{ marginTop: item.links.length > 0 ? '2rem' : '0', position: 'relative', width: '100%', paddingBottom: '56.25%', border: `1px solid ${GOLD}`, borderRadius: '4px', overflow: 'hidden', boxShadow: '0 8px 30px rgba(0,0,0,0.2)' }}>
                          <iframe
                            src={item.embed}
                            title={item.title}
                            loading="lazy"
                            allowFullScreen
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none', display: 'block', backgroundColor: CREAM }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* EXTRAS — hidden for now
      <section id="extras" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: CREAM, padding: '6rem 3rem' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', width: '100%', textAlign: 'center' }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: '400', letterSpacing: '0.18em', marginBottom: '1.5rem', color: BURG, textShadow: '0 1px 2px rgba(128,0,32,0.08)' }}>EXTRAS</h2>
          <p style={{ fontFamily: SANS, fontSize: '0.85rem', letterSpacing: '0.15em', marginBottom: '5rem', color: GOLD, textTransform: 'uppercase' }}>Coming Soon</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', alignItems: 'center' }}>
            {['Satoshis for the Streets', 'Vinyl Music Menus'].map((t, i) => (
              <div key={i} style={{ fontFamily: SANS, fontSize: '1.2rem', fontWeight: '300', color: BURG, padding: '2rem 3rem', border: '1px solid rgba(128,0,32,0.15)', letterSpacing: '0.02em' }}>{t}</div>
            ))}
          </div>
        </div>
      </section>
      */}
      <SectionDivider from={BURG} to={BURG} />

      {/* CONTACT */}
      <section id="contact" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: BURG, padding: isMobile ? '4rem 1.5rem' : '6rem 3rem' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', width: '100%', textAlign: 'center' }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: '400', letterSpacing: '0.18em', marginBottom: '2.5rem', color: CREAM, textShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>GET IN TOUCH</h2>

          <a href="mailto:derek.mcabee@gmail.com"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.75rem', border: `1px solid ${GOLD}`, color: GOLD, padding: isMobile ? '1rem 1.5rem' : '1.25rem 3rem', fontSize: isMobile ? '0.8rem' : '0.9rem', letterSpacing: '0.08em', maxWidth: '100%', wordBreak: 'break-all', textDecoration: 'none', transition: 'all 0.3s ease', fontFamily: SANS, fontWeight: '400' }}
            onMouseEnter={e => { e.target.style.backgroundColor = GOLD; e.target.style.color = BURG; }}
            onMouseLeave={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = GOLD; }}
          ><Mail size={18} />derek.mcabee@gmail.com</a>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ backgroundColor: BURG, borderTop: `1px solid rgba(212,175,55,0.15)`, padding: isMobile ? '2rem 1.5rem' : '2.5rem 3rem' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: isMobile ? 'center' : 'center', flexDirection: isMobile ? 'column' : 'row', flexWrap: 'wrap', gap: '1rem' }}>
          <p style={{ fontFamily: SANS, fontSize: '0.75rem', letterSpacing: '0.08em', color: CREAM, opacity: 0.4, fontWeight: '300' }}>&copy; {new Date().getFullYear()} Derek McAbee</p>
          <a href="https://www.linkedin.com/in/derek-mcabee/" target="_blank" rel="noopener noreferrer"
            style={{ fontFamily: SANS, fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: CREAM, opacity: 0.4, textDecoration: 'none', transition: 'opacity 0.3s ease', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            onMouseEnter={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.color = GOLD; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = '0.4'; e.currentTarget.style.color = CREAM; }}
          ><ExternalLink size={12} />LinkedIn</a>
        </div>
      </footer>
    </div>
  );
}